export enum CardColor {
    RED = 'red',
    BLACK = 'black',
}
